<template>
	<transition name="modal">
		<div class="modal-mask delete-modal-box">
			<div class="modal-wrapper">
				<div class="modal-container">
					<div v-if="validations == null || checkAnyNonValid == 0 || (validations.item1.length > 0 && validations.item2.length < 1 && validations.item3.length < 1)">
						<div class="modal-header">
							<slot name="header">default header</slot>
						</div>

						<div class="modal-body">
							<button class="modal-default-button cta-btn save-btn" @click="$emit('proceedRelease')">Yes</button>
							<button class="modal-default-button cta-btn save-btn" @click="$emit('closeRelease')">No</button>
						</div>
					</div>
					<div v-else>
						<div class="modal-header">
							<h3>Releasing {{months[currDate.getMonth()]}} {{currDate.getFullYear()}} Time Sheet</h3>
						</div>
						<div v-if="validations.item1.length < 1" style="padding-bottom: 10px;">
							There are no time logged against any Projects.
						</div>
						<!-- <div v-if="validations.item2.length > 0" style="padding-bottom: 10px;">
							There are some dates without any time logged. Few dates are:
							<ul>
								<li v-for="index in validations.item2.length > 3 ? 3 : validations.item2.length" :key="index">
									{{ validations.item2[index - 1].Date.substring(0, 10) }}
								</li>
							</ul>
						</div> -->
						<div v-if="validations.item3.length > 0 || validations.item4.length > 0" style="padding-bottom: 10px;">
							The following days have not been entered correct:
							
							<ul style="overflow-y: scroll;height:200px;">
								<div v-if="validations.item3.length > 0">
								<li v-for="index in validations.item3.length" :key="index">
									<div v-if="checkHoliday(validations.item3[index -1].Date.substring(0, 10)) != 1">
										{{ validations.item3[index - 1].Date.substring(0, 10)+" - "+ "No Time Added to Items"}} 
									</div>			
								</li>
								</div>
								
								<!-- Added -- Items descriptions here as item4 -->
								<div v-if="weekendId == 2 || weekendId == null">
									<li v-for="index in validations.item4.length" :key="index">
										<div v-if="convertDate(validations.item4[index - 1].HolidayDate,totalOEHours) == 0">
											<div v-if="(validations.item4[index - 1].DayOfWeeks == 'Sunday' ||  validations.item4[index - 1].DayOfWeeks == 'Saturday') 
											 && !validations.item2.some(item => item.WorkingDay === validations.item4[index - 1].DayOfWeeks)">
												<div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
													{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Weekends "+ "- 24 Hours"}}
												</div>
												<div v-else>
													{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Weekends "+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
												</div>
											</div>
											<div v-else>
												<div v-if="checkHoliday(validations.item4[index -1].HolidayDate) == 1">
													<div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
														{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Non Working Days "+ "- 24 Hours"}}
													</div>
													<div v-else>
														{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Non Working Days"+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
													</div>
												</div>
												<div v-else>
													<div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
														{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged Holiday "+ "- 24 Hours"}}
													</div>
													<div v-else>
														{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged Holiday"+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
													</div>
												</div>
											</div>
											<!-- <div v-if="validations.item4[index - 1].DayOfWeeks == validations.item4[index-1].WorkingHoursDay">
												{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Weekends "+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
											</div> -->
										</div>
										<div v-else>
											<div v-if="(validations.item4[index - 1].DayOfWeeks == 'Sunday' ||  validations.item4[index - 1].DayOfWeeks == 'Saturday') 
											 && !validations.item2.some(item => item.WorkingDay === validations.item4[index - 1].DayOfWeeks)">
												<div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
													{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Weekends "+ "- 24 Hours"}}
												</div>
												<div v-else>
													{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Weekends "+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
												</div>
											</div>
											<div v-else>
												<div v-if="(validations.item4[index - 1].HoursLogged)+'.'+(validations.item4[index - 1].MinutesLogged) > convertDate(validations.item4[index - 1].HolidayDate,totalOEHours)">
													<div v-if="(validations.item4[index - 1].HoursLogged)+'.'+(validations.item4[index - 1].MinutesLogged) >= (convertDate(validations.item4[index - 1].HolidayDate,totalOEHours)*2)">
														{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Double Hours Logged "+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
													</div>
													<div v-else>
														<div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
															{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "More Hours Logged "+ "- 24 Hours"}}
														</div>
														<div v-else>
															{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "More Hours Logged "+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
														</div>
													</div>
												</div>
												<div v-if="(validations.item4[index - 1].HoursLogged)+'.'+(validations.item4[index - 1].MinutesLogged) < convertDate(validations.item4[index - 1].HolidayDate,totalOEHours)">
													<div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
														{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "More Hours Logged "+ "- 24 Hours"}}
													</div>
													<div v-else>
														{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Less Hours Logged " +validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
													</div>
												</div>
											</div>
										</div>
									</li>
								</div>
								<div v-else>
									<li v-for="index in validations.item4.length" :key="index">
										<div v-if="convertDate(validations.item4[index - 1].HolidayDate,totalOEHours) == 0">
											<div v-if="(validations.item4[index - 1].DayOfWeeks == 'Friday' ||  validations.item4[index - 1].DayOfWeeks == 'Saturday') 
											 && !validations.item2.some(item => item.WorkingDay === validations.item4[index - 1].DayOfWeeks)">
												<div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
													{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Weekends "+ "- 24 Hours"}}
												</div>
												<div v-else>
													{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Weekends "+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
												</div>
											</div>
											<div v-else>
												<div v-if="checkHoliday(validations.item4[index -1].HolidayDate) == 1">
                                                    <div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
                                                        {{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Non Working Days "+ "- 24 Hours"}}
                                                    </div>
                                                    <div v-else>
                                                        {{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Non Working Days"+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
                                                        {{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged Holiday "+ "- 24 Hours"}}
                                                    </div>
                                                    <div v-else>
                                                        {{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged Holiday"+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
                                                    </div>
                                                </div>
											</div>
											<!-- <div v-if="validations.item4[index - 1].DayOfWeeks == validations.item4[index-1].WorkingHoursDay">
                                                {{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Weekends "+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
                                            </div> -->
										</div>
										<div v-else>
											<div v-if="(validations.item4[index - 1].DayOfWeeks == 'Friday' ||  validations.item4[index - 1].DayOfWeeks == 'Saturday') 
											 && !validations.item2.some(item => item.WorkingDay === validations.item4[index - 1].DayOfWeeks)">
												<div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
													{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Weekends "+ "- 24 Hours"}}
												</div>
												<div v-else>
													{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Hours Logged on Weekends "+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
												</div>
											</div>
											<div v-else>
												<div v-if="validations.item4[index - 1].HoursLogged+'.'+(validations.item4[index - 1].MinutesLogged) > convertDate(validations.item4[index - 1].HolidayDate,totalOEHours)">
													<div v-if="(validations.item4[index - 1].HoursLogged)+'.'+(validations.item4[index - 1].MinutesLogged) >= (convertDate(validations.item4[index - 1].HolidayDate,totalOEHours)*2)">
														{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Double Hours Logged "+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
													</div>
													<div v-else>
														<div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
															{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "More Hours Logged "+ "- 24 Hours"}}
														</div>
														<div v-else>
															{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "More Hours Logged "+ "- "+validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
														</div>
													</div>
												</div>
												<div v-if="(validations.item4[index - 1].HoursLogged)+'.'+(validations.item4[index - 1].MinutesLogged) < convertDate(validations.item4[index - 1].HolidayDate,totalOEHours)">
													<div v-if="validations.item4[index - 1].HoursLogged == 0 && validations.item4[index - 1].MinutesLogged == 0">
														{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "More Hours Logged "+ "- 24 Hours"}}
													</div>
													<div v-else>
														{{ validations.item4[index - 1].HolidayDate.substring(0, 10)+" - "+ "Less Hours Logged " +validations.item4[index - 1].HoursLogged+"- Hours "+validations.item4[index - 1].MinutesLogged+"-minutes"}}
													</div>
												</div>
											</div>
										</div>
									</li>
								</div>
								
							</ul>
							Do you still want to release this month?
							<div class="modal-body">
								<button class="modal-default-button cta-btn save-btn" @click="$emit('proceedRelease')">Yes</button>
								<button class="modal-default-button cta-btn save-btn" @click="$emit('closeRelease')">No</button>
							</div>
						</div>
						<div v-if="allValid" class="modal-header">
						<slot name="header">default header</slot>
						</div>
						<div v-if="allValid" class="modal-body">
							<button class="modal-default-button cta-btn save-btn" @click="$emit('proceedRelease')">Yes</button>
							<button class="modal-default-button cta-btn save-btn" @click="$emit('closeRelease')">No</button>
						</div>
						<!--<div v-else class="modal-body">
							<button class="modal-default-button cta-btn save-btn" @click="$emit('closeRelease')">Close</button>
						</div>-->
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
    export default {
		name: "ReleaseModal",
		data() {
			return {
				months : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
			};
		},
		methods:{
			convertDate(datahere,totalOEHours){
				const date =new Date(datahere)
				let day= date.getDate();
				let workingHour=totalOEHours[day-1].tragetHour;
				return workingHour;
			},
			workingDay(datahere){
				const date =new Date(datahere)
				var options = { weekday: 'long' };
				return date.toLocaleString('en-US', options);
			},
			checkHoliday(datehere){
				let day = this.workingDay(datehere);
				let holiday=0;
				for(let i=0;i<this.validations.item2.length;i++){
					if(day == this.validations.item2[i].WorkingDay){
						//console.log(day+" -- "+ this.validations.item2[i].WorkingDay+"--"+holiday)
						if(this.validations.item2[i].WorkingHours===0){
							holiday=1;
						}
					}
				}
				return holiday;
				
			}
		},
		computed: {
			validations: function () {
				return this.$store.state.qtime.validateObj;
			},
			currDate: function () {
				return this.$store.state.qtime.currentDate;
			},
			allValid: function () {
				return this.validations.item1.length > 0 && this.validations.item2.length < 1 && this.validations.item3.length < 1;
			},
			totalOEHours: function () {
                return this.$store.state.qtime.monthlyData;
            },
			weekendId: function(){
				return this.$store.state.qtime.weekendId;
			},
            checkAnyNonValid: function() {
				let anyFailed = 0;

				if (this.validations.item3.length > 0) {
					if (this.validations.item3.some(item => this.checkHoliday(item.Date.substring(0, 10)) !== 1)) {
						anyFailed++;
					}
				}

				if (this.$store.state.qtime.weekendId == 2 || this.$store.state.qtime.weekendId == null) {
					if (this.validations.item4.length > 0) {
						this.validations.item4.forEach(item => {
							const isWeekend = item.DayOfWeeks === "Sunday" || item.DayOfWeeks === "Saturday";
							const isWorkingDay = this.validations.item2.some(i => i.WorkingDay === item.DayOfWeeks);
							const isHoliday = this.checkHoliday(item.HolidayDate) === 1;
							const convertedDate = this.convertDate(item.HolidayDate, this.totalOEHours);
							const totalLogged = parseFloat(`${item.HoursLogged || 0}.${item.MinutesLogged || 0}`);

							if (convertedDate === 0) {
								if ((isWeekend && !isWorkingDay) || isHoliday) {
									anyFailed++;
								} else {
									anyFailed++;
								}
							} else {
								if (isWeekend && !isWorkingDay) {
									anyFailed++;
								} else {
									if (totalLogged > convertedDate || totalLogged < convertedDate) {
										anyFailed++;
									}
								}
							}
						});
					}
				} else {
					this.validations.item4.forEach(item => {
						const isWeekend = item.DayOfWeeks === 'Friday' || item.DayOfWeeks === 'Saturday';
						const isWorkingDay = this.validations.item2.some(i => i.WorkingDay === item.DayOfWeeks);
						const holidayCheck = this.checkHoliday(item.HolidayDate);
						const totalHours = this.convertDate(item.HolidayDate, this.totalOEHours);
						const totalLogged = parseFloat(`${item.HoursLogged}.${item.MinutesLogged}`);

						if (totalHours === 0) {
							if ((isWeekend && !isWorkingDay) || holidayCheck == 1) {
								anyFailed++;
							} else {
								anyFailed++;
							}
						} else {
							if (isWeekend && !isWorkingDay) {
								anyFailed++;
							} else if (totalLogged > totalHours || totalLogged < totalHours) {
								anyFailed++;
							}
						}
					});
				}
				return anyFailed;
			}

		}
    };
</script>

<style scoped>
	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: table;
		transition: opacity 0.3s ease;
	}

	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}

	.modal-container {
		width: 300px;
		margin: 0px auto;
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-container .cta-btn {
		padding: 5px 14px;
		background: #ffffff;
		font-size: 11px;
		margin-right: 5px;
	}

	.modal-container .cta-btn:hover,
	.modal-container .cta-btn.active {
		background-color: #003656;
		color: #fff;
	}

	.delete-modal-box .modal-container {
		width: 450px;
		min-height: 170px;
		display: flex;
		display: -webkit-flex;
		display: -moz-flex;
		justify-content: center;
		-webkit-justify-content: center;
		-moz-justify-content: center;
		flex-wrap: wrap;
		-webkit-flex-wrap: wrap;
		align-items: center;
		-moz-align-items: center;
		-webkit-align-items: center;
	}

	.delete-modal-box .modal-container .modal-default-button {
		float: left;
	}

	.delete-modal-box .modal-container .modal-body:after {
		content: "";
		display: table;
		clear: both;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #42b983;
		text-align: center;
	}

	.delete-modal-box .modal-header {
		width: 100%;
		margin-bottom: 20px;
	}

	.delete-modal-box .modal-header h3 {
		color: #8f8f8f;
	}
	.delete-modal-box .modal-body {
		margin: 10px 0;
		display: flex;
		display: -webkit-flex;
		display: -moz-flex;
		justify-content: center;
		-webkit-justify-content: center;
		-moz-justify-content: center;
		align-items: center;
		-moz-align-items: center;
		-webkit-align-items: center;
	}

	.modal-default-button {
		float: right;
	}

	/*
																																		 * The following styles are auto-applied to elements with
																																		 * transition="modal" when their visibility is toggled
																																		 * by Vue.js.
																																		 *
																																		 * You can easily play with the modal transition by editing
																																		 * these styles.
																																		 */

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}
</style>
